import { useTranslation } from "react-i18next";
import CommentsIcon from "src/images/Icons/newIcons/exam/options/comments.svg";

import DefaultOptions from "./DefaultOption";

export default function Comments({ details, settings, actions, dispatch }) {
	const { t } = useTranslation();
	const commentLength = details.commentsCount;

	return (
		<DefaultOptions
			keysToPress={["Meta + k"]}
			optionKey="comments"
			dispatch={dispatch}
			Icon={<CommentsIcon className="icon-normal" />}
			text={t("exam.comments.title")}
			action={actions.toggleSettings}
			settings={settings}
			disabled={!details.visibility?.comments}
			badgeOptions={{
				badgeContent: commentLength,
				color: "secondary",
				hidden: !commentLength,
			}}
		/>
	);
}
